import { useEffect } from 'react';
import '@aws-amplify/ui-react/styles.css';
import '../PrivacyPolicy.css';

export default function PrivacyPolicy() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <div id="privacypolicy-home">
        <div
          id="privacy_policy"
          name="termly-embed"
          data-id={process.env.REACT_APP_TERMLY_PRIVACY_POLICY}
          data-type="iframe"
        ></div>
      </div>
    </>
  );
}
